import Alert from "components/Alert";
import { IAlertProps } from "components/Alert/Alert.interface";
import { Layout } from "components/Layout/Layout.styled";
import { Paragraph, Title } from "components/Text";
import { logout } from "helpers/Login";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AUTH_TYPES } from "store/actions/types";

const Logout = () => {
  const dispatch = useDispatch();
  const [alert, setAlert] = useState<IAlertProps>({
    message: null,
    title: null,
    show: false,
    type: null,
    icon: null,
    onClose: () => {},
  });

  useEffect(() => {
    logout()
      .then((response) => {
        if (response) {
          dispatch({
            type: AUTH_TYPES.LOG_OUT,
          });

          setAlert({
            message: "Se ha cerrado sesión exitosamente.",
            title: "Éxito",
            show: true,
            type: "success",
            icon: "success",
            onClose: () => {},
          });

          setTimeout(() => {
            window.location.href = "/";
          }, 5000);
        }
      })
      .catch((error) => {
        console.error(error);
        setAlert({
          message:
            "Ha ocurrido un error al cerrar sesión. Intenalo nuevamente más tarde.",
          title: "Error",
          show: true,
          type: "danger",
          icon: "error",
          onClose: () => {},
        });
      });
  }, [dispatch]);

  return (
    <Layout className="py-5">
      <div
        className="container justify-content-center align-content-center"
        style={{ height: "50vh" }}
      >
        <Alert {...alert} />
        <Title>Cerrando sesión...</Title>
        <Paragraph>
          Por favor, espere mientras se redirige a la página.
        </Paragraph>
      </div>
    </Layout>
  );
};

export default Logout;
